export default [

     {
          path: '/audit-remidation',
          name: 'AuditRemidation',
          component: () => import("@/views/Page/AuditRemidation/AuditRemidation.vue"),
           meta: {
               title: 'AuditRemidation',
          },
     }
];